export function isToday(birthday: { month?: number; day?: number }) {
  if (!birthday.month || !birthday.day) {
    return false;
  }
  const today = new Date();
  const thisYear = today.getFullYear();
  const thisMonth = today.getMonth() + 1;
  const thisDate = today.getDate();

  if (!isLeapYear(thisYear) && birthday.month === 2 && birthday.day === 29) {
    return thisMonth === 2 && thisDate === 28;
  }
  return thisMonth === birthday.month && thisDate === birthday.day;
}

export function isTomorrow(birthday: { month?: number; day?: number }) {
  if (!birthday.month || !birthday.day) {
    return false;
  }
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowsYear = tomorrow.getFullYear();
  const tomorrowsMonth = tomorrow.getMonth() + 1;
  const tomorrowsDate = tomorrow.getDate();

  if (!isLeapYear(tomorrowsYear) && birthday.month === 2 && birthday.day === 29) {
    return false;
  }

  return tomorrowsMonth === birthday.month && tomorrowsDate === birthday.day;
}

export function isLeapYear(year: number): boolean {
  if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
    return true;
  } else {
    return false;
  }
}

export function isLeapDay(birthday: { month?: number; day?: number }) {
  if (birthday.month === 2 && birthday.day === 29) {
    return true;
  } else {
    return false;
  }
}

// 本日の05:00AM（誕生日通知を表示する境界時刻）のDateをつくる
export function getDailyProcessingDate() {
  const dailyProcessingDate = new Date();
  dailyProcessingDate.setHours(5);
  dailyProcessingDate.setMinutes(0);
  dailyProcessingDate.setSeconds(0);
  dailyProcessingDate.setMilliseconds(0);
  return dailyProcessingDate;
}

export function isBeforeDailyProcessing(date: Date) {
  const dpd = getDailyProcessingDate();
  return dpd.getTime() > date.getTime();
}
